import React, { useState, memo, useRef, useEffect, useLayoutEffect, } from "react";
import "./Detail.css";
import { Col, Form, FormGroup } from "reactstrap";
import Search from "./Components/Search";
import { SpinLoading } from "../../components/Components";
import BillingTable from "./Components/BillingTable";

  
  const Detail = (props) => {
    const { isLoading, isOpenTable } = props;
    
    return (
     
      <Form>
         <div>
          <div>
            <Search />
          </div>

          {isLoading && <SpinLoading />}
          {isOpenTable && <BillingTable/>}
        </div>
      </Form>
    
    );
  };
  
  export const MemoizedDetail = memo(Detail);